import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import BusinessIcon from '@mui/icons-material/Business';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Button, InputAdornment, Paper, Stack, TextField, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoaderOverlay from '../../components/custom-loader/LoaderOverlay';
import { useUserContext } from '../../context/UserContext';
import { validateUserData } from '../../custom/UserExport';
import { formatDate } from '../../custom/commonExport';
import { decryptData } from '../../services/dashboard-service/encryptionService';
import { updateUserProfile } from '../../services/dashboard-service/userService';


const initialErrorState = {
  FirstName: { hasError: false, message: "" },
  LastName: { hasError: false, message: "" },
  Company: { hasError: false, message: "" },
}
function UserProfile() {

  const navigate = useNavigate()

  const { setUser } = useUserContext()
  const [loading, setLoading] = useState(false);
  let [userData, setUserData] = useState([])
  const [errors, setErrors] = useState(initialErrorState);
  let [formData, setFormData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Company: "",
    VIOEnd_Date: "",
  })
  let [oldFormData, setOldFormData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    Company: "",
    VIOEnd_Date: "",
  })

  function handleClickForHome(event) {
    event.preventDefault();
    let homeRoute = userData?.routes?.[0]?.route ? userData?.routes?.[0]?.route : "/"
    navigate(homeRoute);
  }

  function handleClickForProfile(event) {
    event.preventDefault();
    navigate('/user-profile');
  }


  let fetchUserData = async () => {
    setLoading(true)
    let data = validateUserData()
    setUserData(data);
    setLoading(false)
    setFormData({
      FirstName: data?.FirstName || "",
      LastName: data?.LastName || "",
      Email: data?.Email || "",
      Company: data?.Company || "",
      VIOEnd_Date: formatDate(new Date(data?.vio_EndDate)).split(' ')[0] || "",
    })
    setOldFormData({
      FirstName: data?.FirstName || "",
      LastName: data?.LastName || "",
      Email: data?.Email || "",
      Company: data?.Company || "",
      VIOEnd_Date: formatDate(new Date(data?.vio_EndDate)).split(' ')[0] || "",
    })
  }
  useEffect(() => {
    fetchUserData()
  }, [])


  const handleChange = (e) => {
    const { name, value } = e.target
    const regex = /^[a-zA-Z0-9@._-]*$/;
    if (!value.trim() && name == "FirstName") {
      setErrors((prev) => ({ ...prev, [name]: { hasError: true, message: "First Name is Required" } }))
    }
    else if (!regex.test(value)) {
      setErrors((prev) => ({ ...prev, [name]: { hasError: true, message: 'Invalid Character. Please Enter Valid Character.' } }));
    }
    else {
      setErrors((prev) => ({ ...prev, [name]: { hasError: false, message: "" } }))
    }
    setFormData({ ...formData, [name]: value })
  }

  useEffect(() => {
    if (!userData) {
      navigate('/login');
    }
  }, [userData, navigate]);


  const handleCancel = () => {
    setFormData({
      FirstName: userData?.FirstName || "",
      LastName: userData?.LastName || "",
      Email: userData?.Email || "",
      Company: userData?.Company || "",
      VIOEnd_Date: formatDate(new Date(userData?.vio_EndDate)).split(' ')[0] || "",
    })
    setErrors(initialErrorState)
  }

  function validateForm() {
    let hasError = Object.values(errors).some(error => error.hasError)
    if (hasError && formData.FirstName.trim() == "") {
      setErrors((prev) => ({
        ...prev,
        FirstName: { hasError: true, message: "First Name is Required." }
      }))
      toast("First Name is Required", {
        autoClose: true,
        type: "error"
      })
      return false
    }
    else if (hasError) {
      toast("Please Enter Valid Character.", {
        autoClose: true,
        type: "error"
      })
      return false
    }
    else {
      return true
    }
  }

  const updateUserProfileHandler = async (e) => {
    e.preventDefault()
    if (!validateForm()) {
      return;
    }
    if (oldFormData && formData) {
      let hasChange = false;
      for (let key in oldFormData) {
        if (oldFormData[key] !== formData[key]) {
          hasChange = true
          break;
        }
      }
      if (!hasChange) {
        toast("No Changes to Update.", {
          type: "info",
          autoClose: true
        })
        return;
      }
    }
    try {
      setLoading(true)
      let updatedProfileResponse = await updateUserProfile(userData.SecretKey, formData, userData.Token)
      if (updatedProfileResponse && updatedProfileResponse.status === 200) {
        await fetchUserData()
        toast("Profile Update Successfully.", {
          autoClose: true,
          type: "success"
        })
        const userData = localStorage.getItem("userData") ? JSON.parse(decryptData(localStorage.getItem("userData"))) : null;
        setUser(userData)
        setLoading(false)
        return;
      }
      else if (updatedProfileResponse?.status === 401 || updatedProfileResponse?.error && updatedProfileResponse?.error?.statusCode === 401) {
        setLoading(false);
        localStorage.removeItem("userData")
        navigate('/login')
        toast.error('Session Expired.')
      }
      else {
        toast("Try Again Later.", {
          autoClose: true,
          type: "info"
        })
        setLoading(false);
        return;
      }
    } catch (error) {
      toast("Try Again Later.", {
        autoClose: true,
        type: "error"
      })
      setLoading(false)
      return;
    }

  }

  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      href="/"
      onClick={handleClickForHome}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '5px 10px',
        borderRadius: '5px',
        textDecoration: 'none',
        color: '#555', // Base text color
        backgroundColor: 'transparent',
        transition: 'all 0.3s ease',
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.backgroundColor = '#f5f5f5'; // Light gray hover effect
        e.currentTarget.style.color = '#333'; // Darker text on hover
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent'; // Revert background
        e.currentTarget.style.color = '#555'; // Revert text color
      }}
    >
      <HomeIcon fontSize="small" />
    </Link>,
    <ArrowForwardIosIcon
      fontSize="small"
      sx={{ color: '#555', margin: '0 0px' }}
      key="separator-1"
    />,
    <Link
      underline="hover"
      key="2"
      color="inherit"
      onClick={handleClickForProfile}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '5px 10px',
        borderRadius: '5px',
        textDecoration: 'none',
        color: '#555', // Base text color
        backgroundColor: 'transparent',
        transition: 'all 0.3s ease',
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.backgroundColor = '#f5f5f5'; // Light gray hover effect
        e.currentTarget.style.color = '#333'; // Darker text on hover
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.backgroundColor = 'transparent'; // Revert background
        e.currentTarget.style.color = '#555'; // Revert text color
      }}
    >
      <PersonIcon fontSize="small" />
      User Profile
    </Link>,
  ];

  return (
    <div style={{ padding: "1.3rem 2rem", height: "calc(100vh - 200px)" }}>
      <LoaderOverlay loading={loading} />
      <div role="presentation">
        <Stack spacing={1}>
          <Breadcrumbs
            separator=""
            aria-label="breadcrumb"
            sx={{
              lineHeight: "0.5",
              '& ol': {
                margin: 0, // Remove margin from the ordered list (if any)
                padding: 0,
              },
              '& li': {
                margin: 0, // Remove margin from list items
                padding: 0,
              },
            }}
          >
            {breadcrumbs}
          </Breadcrumbs>
        </Stack>
      </div>
      <div className='main-user-profile' style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", height: "100%" }}>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
          <Paper elevation={3} style={{
            padding: "2rem", marginTop: "1.5rem", borderRadius: "8px", backgroundColor: '#fafafa',
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.15)", maxWidth: "500px", width: "100%",
          }}>
            <Typography variant="h5" gutterBottom style={{ fontWeight: "bold", color: "#333" }}>
              User Profile
            </Typography>
            <form onSubmit={(e) => updateUserProfileHandler(e)}>
              <Box
                component="div"
                noValidate
                autoComplete="off"
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  marginTop: 2,
                }}
              >
                <TextField
                  label="First Name"
                  variant="outlined"
                  fullWidth
                  name="FirstName"
                  error={errors.FirstName.hasError}
                  helperText={errors.FirstName.message || ""}
                  FormHelperTextProps={{
                    sx: {
                      backgroundColor: 'rgb(250, 250, 250)',
                      width: "100%"
                    },
                  }}
                  value={formData?.FirstName}
                  required
                  onChange={handleChange}
                  sx={{ background: "#ffffff" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Last Name"
                  name="LastName"
                  variant="outlined"
                  fullWidth
                  onChange={handleChange}
                  value={formData?.LastName}
                  error={errors.LastName.hasError}
                  helperText={errors.LastName.message || ''}
                  FormHelperTextProps={{
                    sx: {
                      backgroundColor: 'rgb(250, 250, 250)',
                      width: "100%"
                    },
                  }}
                  sx={{ background: "#ffffff" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  name="Email"
                  label="Email"
                  type="email"
                  value={formData?.Email}
                  variant="outlined"
                  fullWidth
                  required
                  disabled
                  sx={{ background: "#ffffff" }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  name="Company"
                  label="Company"
                  variant="outlined"
                  fullWidth
                  error={errors.Company.hasError}
                  helperText={errors.Company.message || ''}
                  onChange={handleChange}
                  value={formData?.Company}
                  sx={{ background: "#ffffff" }}
                  FormHelperTextProps={{
                    sx: {
                      backgroundColor: 'rgb(250, 250, 250)',
                      width: "100%"
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BusinessIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: "1rem", justifyContent: 'flex-end' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    type='submit'
                    style={{ marginTop: "1rem", alignSelf: "flex-end" }}
                  >
                    Save Changes
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleCancel}
                    style={{ marginTop: "1rem", alignSelf: "flex-end", backgroundColor: "#f5f5f5", color: "rgba(0, 0, 0, 0.87)" }}
                  >
                    Clear
                  </Button>
                </Box>
              </Box>
            </form>
          </Paper>
        </div>
      </div>
    </div>
  )
}

export default UserProfile